export function pcCycleRegisterEdit() {
  const $block = $('.pc-cycle-doc-form-block');
  if (!$block || $block.length === 0) return;

  $block.each((i, el) => {
    const $t = $(el);

    $t.find('.pc-cycle-doc-form-block-head-edit').on('click', () => {
      $t.find('.form-control, .pc-cycle-doc-line-input').removeAttr('disabled');
    });
  });
}
